
// This handles Google Tag Manager event tracking for cart.
export default function TagEvent(evnt, opts = {}, callback = false) {
    if (!('dataLayer' in window)) {
        console.error('Google Tag Manager not found');
        let err = {
            event: 'error',
            message: 'Google Tag Manager not found',
        };
        try {
            callback && callback(err);
        } catch (error) {
            console.error(error);
        }
        return Promise.resolve(err);
    }

    let event = String(evnt).toLowerCase(),
        data = {
            event,
            eventModel: {
                event,
                ...(opts || {}),
            },
        };

    return new Promise((resolve) => {
        let timeout = setTimeout(() => {
            console.error('tag event timeout', data);
            let err = {
                ...data,
                event: 'error',
                message: 'tag event timeout',
            };
            try {
                callback && callback(err);
            } catch (error) {
                console.error(error);
            }
            resolve(err);
            callback = () => {}; // Clear callback
        }, 3000);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            ...data,
            eventCallback: () => {
                clearTimeout(timeout);
                try {
                    callback && callback(data);
                } catch (error) {
                    console.error(error);
                }
                resolve(data);
            },
        });
    });
}